import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { HR } from 'foundations-components/transitional/components/HR';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { CrmObjectBlockTypename, DateBlockTypename } from 'chatspot-core/__generated__/chirp/com/hubspot/copilot/rpc/v2/CopilotMessageService';
import ComposableBlocks from './ComposableBlocks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ComposableCardHeader = ({
  blocks,
  fallbackTitle,
  callbacks
}) => {
  const filteredBlocks = blocks.filter(block => block.__typename !== DateBlockTypename);
  if (filteredBlocks.length === 0) {
    return null;
  }
  const hasCrmObjectBlock = filteredBlocks.some(block => block.__typename === CrmObjectBlockTypename);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      gap: "200",
      alignItems: "center",
      children: [!hasCrmObjectBlock && fallbackTitle && /*#__PURE__*/_jsx(View, {
        flexGrow: 1,
        children: /*#__PURE__*/_jsx(Text, {
          typography: "heading-50",
          color: "text-core-subtle",
          children: /*#__PURE__*/_jsx(TruncateString, {
            children: fallbackTitle
          })
        })
      }), /*#__PURE__*/_jsx(ComposableBlocks, {
        blocks: filteredBlocks,
        callbacks: callbacks
      })]
    }), /*#__PURE__*/_jsx(HR, {
      marginBlock: "400"
    })]
  });
};
export default ComposableCardHeader;